// tslint:disable:max-line-length

import React from 'react';

export const UtilityNotifications = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C7.4,0,7,0.4,7,1c0,0,0,0.1,0,0.1C5.3,1.6,4,3.1,4,5c0,2.1,0,4-1.7,5.3C1.5,11,1,12,1,13h14c0-1-0.5-2-1.3-2.7 C12,9,12,7.1,12,5c0-1.9-1.3-3.4-3-3.9C9,1.1,9,1,9,1C9,0.4,8.6,0,8,0z M6,14c0,1.1,0.9,2,2,2s2-0.9,2-2H6z" />
    </svg>
  );
};
